export default __webpack_public_path__ + "atomic/_patterns/02-molecules/node-teaser-grid/_node-teaser-grid.twig";